import Store from 'lightningjs-redux';
import { getPauseAdRequestData, getCurrentPauseAd } from '../../../logic/player/player.selectors';

const mapControllers = instance => [
  {
    selector: getPauseAdRequestData,
    callback: value => {
      instance.adRequestData = value;
    },
    shouldBeInvokedOnConnect: true,
  },
  {
    selector: getCurrentPauseAd,
    callback: value => {
      instance.ad = value;
    },
    shouldBeInvokedOnConnect: true,
  },
];

export default Store.control(mapControllers);
